export const deviceSize = {
  mobileS: '500px',
  mobile: '768px',
  tablet: '992px',
  laptop: '1324px',
};